import React, { useEffect, useState } from "react";
import { connect } from "react-redux";

// Formik and Yup
import { useFormik } from "formik";
import * as Yup from "yup";

// Utils component
import TextError from "utils/TextError";

// Dashboard example components
import DataTable from "examples/Tables/DataTable";

// Dashboard components
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDBox from "components/MDBox";
import MDCard from "components/MDCard";
import MDInput from "components/MDInput";

// @mui material components
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Modal from "@mui/material/Modal";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import Alert from "@mui/material/Alert";
import Collapse from "@mui/material/Collapse";
import Grid from "@mui/material/Grid";
import CircularProgress from "@mui/material/CircularProgress";
import { Backdrop } from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import Icon from "@mui/material/Icon";

// React-Select component
import Select from "react-select";

// Custom standard components
import CreateButton from "components/standardized-components/CreateButton";
import DeleteButton from "components/standardized-components/DeleteButton";
import EditButton from "components/standardized-components/EditButton";
 
import {
    getUsageHistory,
    createUsageHistory,
    editUsageHistory,
    deleteUsageHistory,
    getProductsListForDpp,
    getSubModulesByRoleId,
} from "../../../store";

// Cookies
import Cookies from "universal-cookie";

const cookies = new Cookies();

const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: { xs: 500, lg: 800 }, 
    height: "fit-content",
    maxHeight: "90%",
    boxShadow: 24,
    p: 0,
    pt: 2,
    overflow: "auto",
    // overflowX: "hidden",
};

const styleForEdit = { ...style, p: 0, pt: 2 };

const deleteStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 350,
    boxShadow: 24,
    p: 2,
    pt: 3,
};
 
const chargingMethodOptions = [
    { label: "AC Charging", value: "AC Charging" },
    { label: "DC Fast Charging", value: "DC Fast Charging" },
    { label: "DC Rapid Charging", value: "DC Rapid Charging" },
    { label: "Solar Charging", value: "Solar Charging" },
];

const UsageHistory = ({
    getUsageHistoryReducer,
    getUsageHistory,
    createUsageHistory,
    editUsageHistory,
    deleteUsageHistory,
    dppIdSelectedForGlobalFilter,
    dropdownUI,
    getProductsListForDpp,
    getProductsListForDppReducer,
    getSubModulesByRoleId,
    getSubModulesByRoleIdReducer,
}) => {
    let loginDetails = cookies.get("loginDetailsForWMS");
    let jwtToken = loginDetails?.jwt;
    let userId = loginDetails?.data?.userId || "system";
    let roleId = loginDetails?.data?.roleId;

    useEffect(() => {
        if (roleId) getSubModulesByRoleId(roleId, jwtToken);
    }, [roleId]);

    const [modulesData, setModulesData] = useState([]);

    useEffect(() => {
        setModulesData(
            getSubModulesByRoleIdReducer?.subModulesByRoleData?.data
                ? getSubModulesByRoleIdReducer.subModulesByRoleData.data
                : []
        );
    }, [getSubModulesByRoleIdReducer]);
 
    let ItemLocationMapping = modulesData.find(
        (moduleId) => moduleId.moduleId == "16cc0217-cbce-4e3f-874b-89b3fbdd0232"  
    );

    let allocateAccess = ItemLocationMapping?.actionId.includes("a5fde116-00b7-4ce0-939b-2482c5d161e1") || null;
    let viewAccess = ItemLocationMapping?.actionId.includes("896c7b19-7fe5-4306-9f06-2735e57a7b84") || null;
    let editAccess = ItemLocationMapping?.actionId.includes("9acd851e-2dc1-4bd1-a480-e7621d85ace8") || null;
    let deleteAccess = ItemLocationMapping?.actionId.includes("483ae968-cc38-4d30-ba63-887e9d32ba71") || null;

    const [loading, setLoading] = useState(true);

    const [dppOptions, setDPPOptions] = useState([]);
    const [dppIdSelected, setdppIdSelected] = useState("");

    // Fetch Initial Data
    useEffect(() => {
        if (dppIdSelectedForGlobalFilter?.value) {
            getUsageHistory(dppIdSelectedForGlobalFilter?.value, jwtToken);
        } else {
            getUsageHistory(null, jwtToken);
        }
    }, [dppIdSelectedForGlobalFilter, jwtToken]);

    useEffect(() => {
        getProductsListForDpp(jwtToken);
    }, [jwtToken]);

    useEffect(() => {
        let tempDppOptions = [];
        let dataList = getProductsListForDppReducer?.productsListForDpp?.data || [];

        dataList.forEach((item) => {
            tempDppOptions.push({
                label: item.dppCode,
                value: item.dppId,
            });
        });

        setDPPOptions(tempDppOptions);
    }, [getProductsListForDppReducer]);

    // DataTable State
    const [state, setState] = useState({
        columns: [
            { Header: "ID", accessor: "usageHistoryId" },
            { Header: "DPP Code", accessor: "dppCode" },
            { Header: "Total Op. Time", accessor: "totalOperatingTime" },
            { Header: "Charging Cycles", accessor: "totalChargingCycles" },
            { Header: "Discharging Cycles", accessor: "totalDischargingCycles" },
            { Header: "Avg SoC", accessor: "averageSoc" },
            { Header: "Charging Method", accessor: "chargingMethod" },
            { Header: "Energy Charged", accessor: "totalEnergyCharged" },
            { Header: "Energy Discharged", accessor: "totalEnergyDischarged" },
            { Header: "Min Op. Temp", accessor: "minOperatingTemp" },
            { Header: "Max Op. Temp", accessor: "maxOperatingTemp" },
            { Header: "Avg Charge Rate", accessor: "averageChargingRate" },
            {
                Header: "Action",
                accessor: "action",
                cannotSearch: true,
                cannotSort: true,
            },
        ],
        rows: [],
    });

    const { columns, rows } = state;

    useEffect(() => {
        let tempMappedActivity = [];
        let data = getUsageHistoryReducer?.usageHistoryList?.data || [];

        setLoading(getUsageHistoryReducer?.loading || false);

        data.map((item) => {
            const itemObject = {
                usageHistoryId: item.usageHistoryId,
                dppId: item.dppId,
                dppCode: item.dppCode,
                totalOperatingTime: item.totalOperatingTime,
                totalChargingCycles: item.totalChargingCycles,
                totalDischargingCycles:item.totalDischargingCycles,
                averageSoc: item.averageSoc,
                minOperatingTemp: item.minOperatingTemp,
                maxOperatingTemp: item.maxOperatingTemp,
                minChargingTemp: item.minChargingTemp,
                maxChargingTemp: item.maxChargingTemp,
                minStorageTemp: item.minStorageTemp,
                maxStorageTemp: item.maxStorageTemp,
                totalEnergyCharged: item.totalEnergyCharged,
                totalEnergyDischarged: item.totalEnergyDischarged,
                chargingMethod: item.chargingMethod,
                chargingFrequency: item.chargingFrequency,
                averageChargingDuration: item.averageChargingDuration,
                averageChargingRate: item.averageChargingRate,
                action: (
                    <>
                        {deleteAccess && (
                            <DeleteButton
                                tooltip="Delete"
                                variant="gradient"
                                color="error"
                                iconOnly
                                type="button"
                                style={{ marginRight: "5px" }}
                                onClick={() => handleOpenDeleteModal(item)}
                            >
                                <Icon>delete</Icon>
                            </DeleteButton>
                        )}
                        {editAccess && (
                            <EditButton
                                tooltip="Edit"
                                variant="gradient"
                                color="success"
                                iconOnly
                                type="button"
                                onClick={() => handleOpenUpdateModal(item)}
                                style={{ marginRight: "5px" }}
                            >
                                <Icon>edit_sharp</Icon>
                            </EditButton>
                        )}
                    </>
                ),
            };
            tempMappedActivity.push(itemObject);
        });

        setState((prevState) => ({ ...prevState, rows: tempMappedActivity }));
    }, [getUsageHistoryReducer]);

    // ================= CREATE LOGIC =================
    const [openCreateModal, setOpenCreateModal] = useState(false);
    const [isSuccessCreate, setIsSuccessCreate] = useState(false);
    const [isErrorCreate, setIsErrorCreate] = useState(false);
    const [errorMsgCreate, setErrorMsgCreate] = useState("");
    const [createButtonName, setCreateButtonName] = useState("Create");

    const handleOpenCreateModal = () => {
        setOpenCreateModal(true);
        formik.setErrors({});
    };

    const handleCloseCreateModal= (event, reason) => {
    if (reason === "backdropClick")
      return;
        setOpenCreateModal(false);
        formik.resetForm();
        setdppIdSelected("");
    };

    useEffect(() => {
        if (isSuccessCreate) setTimeout(() => setIsSuccessCreate(false), 3000);
        if (isErrorCreate) setTimeout(() => setIsErrorCreate(false), 3000);
    }, [isSuccessCreate, isErrorCreate]);

    const initialValues = {
        DPPID: "",
        totalOperatingTime: "",
        totalChargingCycles: "",
        totalDischargingCycles:"",
        averageSoc: "",
        minOperatingTemp: "",
        maxOperatingTemp: "",
        minChargingTemp: "",
        maxChargingTemp: "",
        minStorageTemp: "",
        maxStorageTemp: "",
        totalEnergyCharged: "",
        totalEnergyDischarged: "",
        chargingMethod: null,
        chargingFrequency: "",
        averageChargingDuration: "",
        averageChargingRate: "",
    };

    const validationSchema = Yup.object({
        DPPID: Yup.object().required("Select DPP Code"),
        totalOperatingTime: Yup.number().typeError("Must be a number").required("  "),
        totalChargingCycles: Yup.number().typeError("Must be a number").required("  "),
        totalDischargingCycles: Yup.number().typeError("Must be a number").required("  "),
        averageSoc: Yup.number().typeError("Must be a number").required("  "),
        minOperatingTemp: Yup.number().typeError("Must be a number").required("  "),
        maxOperatingTemp: Yup.number().typeError("Must be a number").required("  "),
        minChargingTemp: Yup.number().typeError("Must be a number").required("  "),
        maxChargingTemp: Yup.number().typeError("Must be a number").required("  "),
        minStorageTemp: Yup.number().typeError("Must be a number").required("  "),
        maxStorageTemp: Yup.number().typeError("Must be a number").required("  "),
        totalEnergyCharged: Yup.number().typeError("Must be a number").required("  "),
        totalEnergyDischarged: Yup.number().typeError("Must be a number").required("  "),
        chargingMethod: Yup.object().nullable().required("  "),
        chargingFrequency: Yup.number().typeError("Must be a number").required("  "),
        averageChargingDuration: Yup.number().typeError("Must be a number").required("  "),
        averageChargingRate: Yup.number().typeError("Must be a number").required("  "),
    });

    const onSubmit = async (values, { resetForm }) => {
        setCreateButtonName("Please wait...");
        const payload = {
            dppId: values.DPPID?.value,
            totalOperatingTime: (values.totalOperatingTime),
            totalChargingCycles: (values.totalChargingCycles),
            totalDischargingCycles: (values.totalDischargingCycles),
            averageSoc: String(values.averageSoc),
            minOperatingTemp: String(values.minOperatingTemp),
            maxOperatingTemp: String(values.maxOperatingTemp),
            minChargingTemp: String(values.minChargingTemp),
            maxChargingTemp: String(values.maxChargingTemp),
            minStorageTemp: String(values.minStorageTemp),
            maxStorageTemp: String(values.maxStorageTemp),
            totalEnergyCharged: String(values.totalEnergyCharged),
            totalEnergyDischarged: String(values.totalEnergyDischarged),
            chargingMethod: values.chargingMethod?.value,
            chargingFrequency: String(values.chargingFrequency),
            averageChargingDuration: String(values.averageChargingDuration),
            averageChargingRate: String(values.averageChargingRate),
            userId: userId,
        };

        let res = await createUsageHistory(payload, jwtToken);

        if (res.status) {
            setIsSuccessCreate(true);
            getUsageHistory(dppIdSelectedForGlobalFilter?.value, jwtToken);
            setTimeout(() => {
                setCreateButtonName("Create");
                handleCloseCreateModal();
            }, 2000);
        } else {
            setErrorMsgCreate(res?.data?.msg || "Something went wrong");
            setIsErrorCreate(true);
            setCreateButtonName("Create");
        }
    };

    const formik = useFormik({
        initialValues,
        validationSchema,
        onSubmit,
    });

    // ================= EDIT LOGIC =================
    const [openUpdateModal, setOpenUpdateModal] = useState(false);
    const [singleDataForUpdate, setSingleDataForUpdate] = useState({});
    const [isSuccessForUpdate, setIsSuccessForUpdate] = useState(false);
    const [isErrorForUpdate, setIsErrorForUpdate] = useState(false);
    const [errorMsgForUpdate, setErrorMsgForUpdate] = useState("");
    const [editButtonName, setEditButtonName] = useState("Update");

    const handleOpenUpdateModal = (data) => {
        setSingleDataForUpdate(data);
        setOpenUpdateModal(true);
    };

    const handleCloseUpdateModal = (event, reason) => {
    if (reason === "backdropClick")
      return;
        setOpenUpdateModal(false);
        formikForUpdate.resetForm();
    };

    useEffect(() => {
        if (isSuccessForUpdate) setTimeout(() => setIsSuccessForUpdate(false), 3000);
        if (isErrorForUpdate) setTimeout(() => setIsErrorForUpdate(false), 3000);
    }, [isSuccessForUpdate, isErrorForUpdate]);

    const initialValueForUpdate = {
        usageHistoryId: singleDataForUpdate.usageHistoryId || "",
        DPPID: singleDataForUpdate.dppCode || "",
        totalOperatingTime: singleDataForUpdate.totalOperatingTime || "",
        totalChargingCycles: singleDataForUpdate.totalChargingCycles || "",
        totalDischargingCycles: singleDataForUpdate.totalDischargingCycles || "",
        averageSoc: singleDataForUpdate.averageSoc || "",
        minOperatingTemp: singleDataForUpdate.minOperatingTemp || "",
        maxOperatingTemp: singleDataForUpdate.maxOperatingTemp || "",
        minChargingTemp: singleDataForUpdate.minChargingTemp || "",
        maxChargingTemp: singleDataForUpdate.maxChargingTemp || "",
        minStorageTemp: singleDataForUpdate.minStorageTemp || "",
        maxStorageTemp: singleDataForUpdate.maxStorageTemp || "",
        totalEnergyCharged: singleDataForUpdate.totalEnergyCharged || "",
        totalEnergyDischarged: singleDataForUpdate.totalEnergyDischarged || "",
        chargingMethod: singleDataForUpdate.chargingMethod
            ? chargingMethodOptions.find((opt) => opt.value === singleDataForUpdate.chargingMethod) || null
            : null,
        chargingFrequency: singleDataForUpdate.chargingFrequency || "",
        averageChargingDuration: singleDataForUpdate.averageChargingDuration || "",
        averageChargingRate: singleDataForUpdate.averageChargingRate || "",
    };

    const validationSchemaEdit = Yup.object({
        totalOperatingTime: Yup.number().typeError("Must be a number").required("  "),
        totalChargingCycles: Yup.number().typeError("Must be a number").required("  "),
        totalDischargingCycles: Yup.number().typeError("Must be a number").required("  "),
        averageSoc: Yup.number().typeError("Must be a number").required("  "),
        minOperatingTemp: Yup.number().typeError("Must be a number").required("  "),
        maxOperatingTemp: Yup.number().typeError("Must be a number").required("  "),
        minChargingTemp: Yup.number().typeError("Must be a number").required("  "),
        maxChargingTemp: Yup.number().typeError("Must be a number").required("  "),
        minStorageTemp: Yup.number().typeError("Must be a number").required("  "),
        maxStorageTemp: Yup.number().typeError("Must be a number").required("  "),
        totalEnergyCharged: Yup.number().typeError("Must be a number").required("  "),
        totalEnergyDischarged: Yup.number().typeError("Must be a number").required("  "),
        chargingMethod: Yup.object().nullable().required("  "),
        chargingFrequency: Yup.number().typeError("Must be a number").required("  "),
        averageChargingDuration: Yup.number().typeError("Must be a number").required("  "),
        averageChargingRate: Yup.number().typeError("Must be a number").required("  "),
    });

    const onSubmitForUpdate = async (values) => {
        setEditButtonName("Please wait...");
        const payload = {
            usageHistoryId: parseInt(values.usageHistoryId),
            dppId: singleDataForUpdate.dppId,
            totalOperatingTime: (values.totalOperatingTime),
            totalChargingCycles: (values.totalChargingCycles),
            totalDischargingCycles: (values.totalDischargingCycles),
            averageSoc: String(values.averageSoc),
            minOperatingTemp: String(values.minOperatingTemp),
            maxOperatingTemp: String(values.maxOperatingTemp),
            minChargingTemp: String(values.minChargingTemp),
            maxChargingTemp: String(values.maxChargingTemp),
            minStorageTemp: String(values.minStorageTemp),
            maxStorageTemp: String(values.maxStorageTemp),
            totalEnergyCharged: String(values.totalEnergyCharged),
            totalEnergyDischarged: String(values.totalEnergyDischarged),
            chargingMethod: values.chargingMethod?.value,
            chargingFrequency: String(values.chargingFrequency),
            averageChargingDuration: String(values.averageChargingDuration),
            averageChargingRate: String(values.averageChargingRate),
            userId: userId,
        };

        let res = await editUsageHistory(payload, jwtToken);

        if (res.status) {
            setIsSuccessForUpdate(true);
            getUsageHistory(dppIdSelectedForGlobalFilter?.value, jwtToken);
            setTimeout(() => {
                handleCloseUpdateModal();
                setEditButtonName("Update");
            }, 2000);
        } else {
            setIsErrorForUpdate(true);
            setErrorMsgForUpdate(res?.data?.msg || "Failed to update");
            setEditButtonName("Update");
        }
    };

    const formikForUpdate = useFormik({
        initialValues: initialValueForUpdate,
        validationSchema: validationSchemaEdit,
        onSubmit: onSubmitForUpdate,
        enableReinitialize: true,
    });

    // ================= DELETE LOGIC =================
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const [singleDataForDelete, setSingleDataForDelete] = useState({});
    const [isSuccessForDelete, setIsSuccessForDelete] = useState(false);
    const [isErrorForDelete, setIsErrorForDelete] = useState(false);
    const [errorMsgForDelete, setErrorMsgForDelete] = useState("");
    const [deleteButtonName, setDeleteButtonName] = useState("Delete");

    const handleOpenDeleteModal = (data) => {
        setSingleDataForDelete(data);
        setOpenDeleteModal(true);
    };

    const handleCloseDeleteModal = () => {
        setOpenDeleteModal(false);
    };

    useEffect(() => {
        if (isSuccessForDelete) setTimeout(() => setIsSuccessForDelete(false), 2000);
        if (isErrorForDelete) setTimeout(() => setIsErrorForDelete(false), 3000);
    }, [isSuccessForDelete, isErrorForDelete]);

    const deleteRecord = async () => {
        setDeleteButtonName("Please wait...");
        let id = singleDataForDelete.usageHistoryId;
        let udBy = userId;

        let res = await deleteUsageHistory(id, udBy, jwtToken);

        if (res.status) {
            setIsSuccessForDelete(true);
            getUsageHistory(dppIdSelectedForGlobalFilter?.value, jwtToken);
            setTimeout(() => {
                handleCloseDeleteModal();
                setDeleteButtonName("Delete");
            }, 2000);
        } else {
            setIsErrorForDelete(true);
            setErrorMsgForDelete(res?.data?.msg || "Failed to delete");
            setDeleteButtonName("Delete");
        }
    };

    return (
        <div>
            <MDBox pt={0} pb={0} mb={-2.5}>
                <Grid container spacing={6}>
                    <Grid item xs={12}>
                        {/* Header Actions */}
                        <MDBox display="flex" justifyContent="space-between" alignItems="center" p={0} mb={-4.5} mt={-1}>
                            <MDBox color="text" px={2} ml={-2} mb={4}>
                                {allocateAccess && (
                                    <Tooltip >
                                        <CreateButton tooltip="Add Usage History" color="info" variant="contained" type="button" iconOnly onClick={handleOpenCreateModal} style={{ borderRadius: "5px" }} size="small">
                                            <Icon>add</Icon>
                                        </CreateButton>
                                    </Tooltip>
                                )}
                            </MDBox>
                            {dropdownUI && (
                                <MDBox mb={4} mr={1}>
                                    {dropdownUI}
                                </MDBox>
                            )}
                        </MDBox>

                        {/* DataTable */}
                        <MDBox pt={0}>
                            <DataTable
                                table={{ columns, rows }}
                                isSorted={true}
                                tableSearch={true}
                                entriesPerPage={{ defaultValue: 5, entries: [5, 10, 15, 20, 25] }}
                                showTotalEntries={true}
                                noEndBorder
                            />
                        </MDBox>

                        {/* CREATE MODAL */}
                        <Modal open={openCreateModal} onClose={handleCloseCreateModal}>
                            <MDCard sx={style}>
                                <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                                    <MDTypography variant="h5" fontWeight="medium" flexGrow={1}>
                                        Create Usage History
                                    </MDTypography>
                                    <Tooltip title="Close">
                                        <IconButton style={{
                                            background: "whitesmoke", color: "black", borderRadius: 5, marginRight: "10px",
                                            marginTop: "4px",
                                        }} onClick={handleCloseCreateModal}>
                                            <CloseIcon />
                                        </IconButton>
                                    </Tooltip>
                                </MDBox>
                                <hr style={{ marginTop: "0.5rem", marginBottom: "1rem" }} />

                                <MDBox pt={1} pb={3} px={3}>
                                    <MDBox component="form" role="form" onSubmit={formik.handleSubmit}>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} lg={4}>
                                                <MDBox mb={1}>
                                                    <MDTypography variant="h6">DPP Code</MDTypography>
                                                    <Select
                                                        isClearable
                                                        className="select-css"
                                                        placeholder="Choose one..."
                                                        name="DPPID"
                                                        value={dppIdSelected}
                                                        options={dppOptions}
                                                        onBlur={() => formik.handleBlur({ target: { name: "DPPID" } })}
                                                        onChange={(selectedOption) => {
                                                            setdppIdSelected(selectedOption);
                                                            formik.setFieldValue("DPPID", selectedOption);
                                                        }}
                                                        menuPortalTarget={document.body}
                                                        styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                                                    />
                                                    {formik.touched.DPPID && formik.errors.DPPID && <TextError msg={formik.errors.DPPID} />}
                                                </MDBox>
                                            </Grid>

                                            {[
                                                { name: "totalOperatingTime", label: "Total Operating Time" },
                                                { name: "totalChargingCycles", label: "Total Charging Cycles" },
                                                { name: "totalDischargingCycles", label: "Total Discharging Cycles" },
                                                { name: "averageSoc", label: "Average SoC" },
                                                { name: "minOperatingTemp", label: "Min Operating Temp" },
                                                { name: "maxOperatingTemp", label: "Max Operating Temp" },
                                                { name: "minChargingTemp", label: "Min Charging Temp" },
                                                { name: "maxChargingTemp", label: "Max Charging Temp" },
                                                { name: "minStorageTemp", label: "Min Storage Temp" },
                                                { name: "maxStorageTemp", label: "Max Storage Temp" },
                                                { name: "totalEnergyCharged", label: "Total Energy Charged" },
                                                { name: "totalEnergyDischarged", label: "Total Energy Discharged" },
                                                { name: "chargingFrequency", label: "Charging Frequency" },
                                                { name: "averageChargingDuration", label: "Avg Charging Duration" },
                                                { name: "averageChargingRate", label: "Avg Charging Rate" },
                                            ].map((field, idx) => (
                                                <Grid item xs={12} lg={4} key={idx}>
                                                    <MDBox mb={1} ml={0}>
                                                        <MDTypography variant="h6">{field.label}</MDTypography>
                                                        <MDInput
                                                            size="small"
                                                            type="number"
                                                            name={field.name}
                                                            fullWidth
                                                            autoComplete="off"
                                                            value={formik.values[field.name]}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            error={formik.touched[field.name] && Boolean(formik.errors[field.name])}
                                                        />
                                                        {formik.touched[field.name] && formik.errors[field.name] && <TextError msg={formik.errors[field.name]} />}
                                                    </MDBox>
                                                </Grid>
                                            ))}

                                            {/* Dropdown for Charging Method */}
                                            <Grid item xs={12} lg={4}>
                                                <MDBox mb={1}>
                                                    <MDTypography variant="h6">Charging Method</MDTypography>
                                                    <Select
                                                        isClearable
                                                        className="select-css"
                                                        placeholder="Select Method..."
                                                        name="chargingMethod"
                                                        value={formik.values.chargingMethod}
                                                        options={chargingMethodOptions}
                                                        onChange={(option) => formik.setFieldValue("chargingMethod", option)}
                                                        onBlur={() => formik.setFieldTouched("chargingMethod", true)}
                                                        menuPortalTarget={document.body}
                                                        styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                                                    />
                                                    {formik.touched.chargingMethod && formik.errors.chargingMethod && <TextError msg={formik.errors.chargingMethod} />}
                                                </MDBox>
                                            </Grid>

                                            <Grid item xs={12}>
                                                <Collapse in={isErrorCreate}><Alert severity="error" action={<IconButton size="small" onClick={() => setIsErrorCreate(false)}><CloseIcon fontSize="inherit" /></IconButton>}>{errorMsgCreate}</Alert></Collapse>
                                                <Collapse in={isSuccessCreate}><Alert severity="success" action={<IconButton size="small" onClick={() => setIsSuccessCreate(false)}><CloseIcon fontSize="inherit" /></IconButton>}>Created Successfully</Alert></Collapse>
                                                <MDBox mt={2}>
                                                    <MDButton color="info" type="submit" fullWidth disabled={createButtonName === "Please wait..."}>{createButtonName}</MDButton>
                                                </MDBox>
                                            </Grid>
                                        </Grid>
                                    </MDBox>
                                </MDBox>
                            </MDCard>
                        </Modal>

                        {/* UPDATE MODAL */}
                        <Modal open={openUpdateModal} onClose={handleCloseUpdateModal}>
                            <MDCard sx={styleForEdit}>
                                <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                                    <MDTypography variant="h4" fontWeight="medium" flexGrow={1}>
                                        Update Usage History
                                    </MDTypography>
                                    <Tooltip title="Close">
                                        <IconButton style={{
                                            background: "whitesmoke", color: "black", borderRadius: 5, marginRight: "10px",
                                            marginTop: "4px",
                                        }} onClick={handleCloseUpdateModal}>
                                            <CloseIcon />
                                        </IconButton>
                                    </Tooltip>
                                </MDBox>
                                <hr style={{ marginTop: "0.5rem", marginBottom: "1rem" }} />

                                <MDBox pt={1} pb={3} px={3}>
                                    <MDBox component="form" role="form" onSubmit={formikForUpdate.handleSubmit}>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} lg={4}>
                                                <MDBox mb={1}>
                                                    <MDTypography variant="h6">DPP Code</MDTypography>
                                                    <MDInput size="small" type="text" name="DPPID" fullWidth disabled={true} value={formikForUpdate.values.DPPID} />
                                                </MDBox>
                                            </Grid>

                                            {[
                                                { name: "totalOperatingTime", label: "Total Operating Time" },
                                                { name: "totalChargingCycles", label: "Total Charging Cycles" },
                                                { name: "totalDischargingCycles", label: "Total Discharging Cycles" },
                                                { name: "averageSoc", label: "Average SoC" },
                                                { name: "minOperatingTemp", label: "Min Operating Temp" },
                                                { name: "maxOperatingTemp", label: "Max Operating Temp" },
                                                { name: "minChargingTemp", label: "Min Charging Temp" },
                                                { name: "maxChargingTemp", label: "Max Charging Temp" },
                                                { name: "minStorageTemp", label: "Min Storage Temp" },
                                                { name: "maxStorageTemp", label: "Max Storage Temp" },
                                                { name: "totalEnergyCharged", label: "Total Energy Charged" },
                                                { name: "totalEnergyDischarged", label: "Total Energy Discharged" },
                                                { name: "chargingFrequency", label: "Charging Frequency" },
                                                { name: "averageChargingDuration", label: "Avg Charging Duration" },
                                                { name: "averageChargingRate", label: "Avg Charging Rate" },
                                            ].map((field, idx) => (
                                                <Grid item xs={12} lg={4} key={idx}>
                                                    <MDBox mb={1} ml={0}>
                                                        <MDTypography variant="h6">{field.label}</MDTypography>
                                                        <MDInput
                                                            size="small"
                                                            type="number"
                                                            name={field.name}
                                                            fullWidth
                                                            autoComplete="off"
                                                            value={formikForUpdate.values[field.name]}
                                                            onChange={formikForUpdate.handleChange}
                                                            onBlur={formikForUpdate.handleBlur}
                                                            error={formikForUpdate.touched[field.name] && Boolean(formikForUpdate.errors[field.name])}
                                                        />
                                                        {formikForUpdate.touched[field.name] && formikForUpdate.errors[field.name] && <TextError msg={formikForUpdate.errors[field.name]} />}
                                                    </MDBox>
                                                </Grid>
                                            ))}

                                            {/* Dropdown for Charging Method */}
                                            <Grid item xs={12} lg={4}>
                                                <MDBox mb={2}>
                                                    <MDTypography variant="h6">Charging Method</MDTypography>
                                                    <Select
                                                        isClearable
                                                        className="select-css"
                                                        placeholder="Select Method..."
                                                        name="chargingMethod"
                                                        value={formikForUpdate.values.chargingMethod}
                                                        options={chargingMethodOptions}
                                                        onChange={(option) => formikForUpdate.setFieldValue("chargingMethod", option)}
                                                        onBlur={() => formikForUpdate.setFieldTouched("chargingMethod", true)}
                                                        menuPortalTarget={document.body}
                                                        styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                                                    />
                                                    {formikForUpdate.touched.chargingMethod && formikForUpdate.errors.chargingMethod && <TextError msg={formikForUpdate.errors.chargingMethod} />}
                                                </MDBox>
                                            </Grid>

                                            <Grid item xs={12}>
                                                <Collapse in={isErrorForUpdate}><Alert severity="error" action={<IconButton size="small" onClick={() => setIsErrorForUpdate(false)}><CloseIcon fontSize="inherit" /></IconButton>}>{errorMsgForUpdate}</Alert></Collapse>
                                                <Collapse in={isSuccessForUpdate}><Alert severity="success" action={<IconButton size="small" onClick={() => setIsSuccessForUpdate(false)}><CloseIcon fontSize="inherit" /></IconButton>}>Updated successfully</Alert></Collapse>
                                                <MDBox mt={2}>
                                                    <MDButton color="info" type="submit" fullWidth disabled={editButtonName === "Please wait..."}>{editButtonName}</MDButton>
                                                </MDBox>
                                            </Grid>
                                        </Grid>
                                    </MDBox>
                                </MDBox>
                            </MDCard>
                        </Modal>

                        {/* DELETE MODAL */}
                        <Modal open={openDeleteModal} onClose={handleCloseDeleteModal}>
                            <MDCard sx={deleteStyle}>
                                <MDTypography>Are you sure you want to delete?</MDTypography>
                                <MDBox mt={2} display="flex" justifyContent="space-between">
                                    <MDButton color="info" variant="outlined" onClick={handleCloseDeleteModal}>Cancel</MDButton>
                                    <MDButton color="error" onClick={deleteRecord} disabled={deleteButtonName === "Please wait..."}>{deleteButtonName}</MDButton>
                                </MDBox>
                                <MDBox mt={2}>
                                    <Collapse in={isErrorForDelete}><Alert severity="error" action={<IconButton size="small" onClick={() => setIsErrorForDelete(false)}><CloseIcon fontSize="inherit" /></IconButton>}>{errorMsgForDelete}</Alert></Collapse>
                                    <Collapse in={isSuccessForDelete}><Alert severity="success" action={<IconButton size="small" onClick={() => setIsSuccessForDelete(false)}><CloseIcon fontSize="inherit" /></IconButton>}>Deleted Successfully</Alert></Collapse>
                                </MDBox>
                            </MDCard>
                        </Modal>
                    </Grid>
                </Grid>
            </MDBox>

            {loading && (
                <Backdrop sx={{ color: "blue", zIndex: (theme) => theme.zIndex.drawer + 1 }} open>
                    <CircularProgress color="inherit" />
                </Backdrop>
            )}
            <ToastContainer />
        </div>
    );
};

// Redux mapping
const mapStateToProps = (state) => ({
    getUsageHistoryReducer: state.getUsageHistoryReducer,
    getProductsListForDppReducer: state.getProductsListForDppReducer,
    getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,
});

const mapDispatchToProps = (dispatch) => ({
    getSubModulesByRoleId: (roleId, jwtToken) => dispatch(getSubModulesByRoleId(roleId, jwtToken)),
    getUsageHistory: (dppId, jwtToken) => dispatch(getUsageHistory(dppId, jwtToken)),
    createUsageHistory: (payload, jwtToken) => dispatch(createUsageHistory(payload, jwtToken)),
    editUsageHistory: (payload, jwtToken) => dispatch(editUsageHistory(payload, jwtToken)),
    deleteUsageHistory: (id, udBy, jwtToken) => dispatch(deleteUsageHistory(id, udBy, jwtToken)),
    getProductsListForDpp: (jwtToken) => dispatch(getProductsListForDpp(jwtToken)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UsageHistory);